import { h, Component } from 'preact';
import { Link } from 'preact-router';
import { stockAPIStreamer } from '@os/cloudquote';
import { formatNumber } from '../../lib/util';
import { FinanceSpinner } from '../glyphs';
import Flag from '../flags';
import style from './style';

export default class MajorCurrencies extends Component {
	state = { data: [] }

	handleData = (data) => {
		this.setState({ data: data.rows });
	}

	componentWillMount() {
		this.streamer = stockAPIStreamer(['EUR-USD','USD-JPY','GBP-USD','USD-CAD'], 'getStockPrice')
			.on('data', this.handleData);
	}

	componentWillUnmount() {
		this.streamer && this.streamer.end();
	}

	render(props, { data }) {
		if (!data || !data.length) return (
			<div class={style['major-currencies']}>
				<FinanceSpinner />
			</div>
		);

		return (
			<div class={style['major-currencies']}>
				<div class={style.inner}>
					<MajorCurrenciesRow fromFlag="europe" toFlag="usa" symbol={data[0].Symbol} desc="Euro to Dollar" ratio={'1 EUR = ' + formatNumber(data[0].Price, { Decimals: 2 }) + ' USD'} />
					<MajorCurrenciesRow fromFlag="usa"    toFlag="japan" symbol={data[1].Symbol} desc="Dollar to Yen" ratio={'1 USD = ' + formatNumber(data[1].Price, { Decimals: 0 }) + ' YEN'} />
					<MajorCurrenciesRow fromFlag="uk"     toFlag="usa" symbol={data[2].Symbol} desc="GBP to Dollar" ratio={'1 GBP = ' + formatNumber(data[2].Price, { Decimals: 2 }) + ' USD'} />
					<MajorCurrenciesRow fromFlag="usa"    toFlag="canada" symbol={data[3].Symbol} desc="Dollar to CAD" ratio={'1 USD = ' + formatNumber(data[3].Price, { Decimals: 2 }) + ' CAD'} />
				</div>
			</div>
		);
	}
}

export const MajorCurrenciesRow = ({ fromFlag, toFlag, symbol, desc, ratio }) => (
	<div class={style.row}>
		<div class={style.flag}>
			<Flag country={fromFlag} />
		</div>
		<div class={style.desc}>
			<Link href={`/stockQuote/${symbol}`}>{ desc }</Link>
			<div class={style.ratio}>{ ratio }</div>
		</div>
		<div class={style.flag}>
			<Flag country={toFlag} />
		</div>
	</div>
);



// WEBPACK FOOTER //
// ../node_modules/@cube/finance-components/src/components/currencies/index.js